'use client';
import React from 'react';
import { useTranslation } from 'next-i18next';
import { useSelector } from 'react-redux';
import { appSettingsState } from '@/app/lib/redux';

const PnCDisclaimer = () => {
  const { t } = useTranslation('common');
  const { pNcDisclaimer } = useSelector(appSettingsState);
  if (!pNcDisclaimer) return null;

  return (
    <div className="mt-2" style={{ fontSize: '0.8rem' }} dangerouslySetInnerHTML={{ __html: t('P&C_DISCLAIMER') }} />
  );
};

export default PnCDisclaimer;
